// Copyright (c) 2019 Deere & Company

import './busy-counter-loading-indicator.scss';
import { LoadingIndicator } from './index';
import PropTypes from 'prop-types';
import React from 'react';

const BusyCounterLoadingIndicator = props => (
    props.busyCounter ? (
        <div className="full-page-loading-indicator">
            <LoadingIndicator />
        </div>
    ) : null
);

BusyCounterLoadingIndicator.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
};
export default BusyCounterLoadingIndicator;
